import { Button } from '@/components/ui/button';
import { FlexCol } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { Grid2X2, Plus } from 'lucide-react';
import { FC } from 'react';

interface EmptyStateProps {
  onCreateTableView: () => void;
  isCreating?: boolean;
}

export const EmptyState: FC<EmptyStateProps> = ({
  onCreateTableView,
  isCreating,
}) => {
  return (
    <FlexCol
      p="4"
      className="border-2 border-dashed border-neutral-200 rounded-lg bg-white w-full"
      alignItems="center"
      justifyContent="center"
      gap="4"
    >
      <Grid2X2 className="h-10 w-10 bg-neutral-100 rounded-md p-3" />
      <FlexCol gap="2" alignItems="center" justifyContent="center">
        <Text variant="body-sm-bold">No table views yet</Text>
        <Text className="text-gray-500" variant="body-sm">
          Create your first table view to start extracting information from
          files
        </Text>
      </FlexCol>
      <Button onClick={onCreateTableView} disabled={isCreating}>
        <Plus />
        Create Table View
      </Button>
    </FlexCol>
  );
};
